// @flow

export const NONE_OF_THESE_PEOPLE_ID = 'NONE';

export const EDE_BACKGROUND_PRIMARY_INFO_PATH = 'ede.background.primaryInfo';
export const PURCHASE_APPLICANTS_FORM_PATH = 'purchase.applicants.form';

// Household Members Route
export const HOUSEHOLD_MEMBER_FORM_NAME: 'householdMembers' = 'householdMembers';

// Immigration Route
export const LAWFUL_PRESENCE_INDICATOR_LIST_PATH =
  'lawfulPresence.lawfulPresenceStatusIndicatorList';

export const LAWFUL_PRESENCE_DOCUMENTATION_PATH = 'lawfulPresence.lawfulPresenceDocumentation';

// Optional Questions Page
export const BLIND_OR_DISABLED_INDICATOR_PATH = 'nonMagi.blindOrDisabledIndicator';
export const LONG_TERM_CARE_INDICATOR_PATH = 'nonMagi.longTermCareIndicator';

// Medicaid and CHIP Questions Page
export const MEMBER_MEDICAID_CHIP_RECENT_INELIGIBILITY_PATH =
  'member_medicaid_chip_recent_ineligibility';
export const MEMBER_MEDICAID_CHIP_RECENT_INELIGIBILITY_HOUSEHOLD_PATH =
  'member_medicaid_chip_recent_ineligibility_household';
export const MEDICAID_DENIED_INDICATOR_PATH = 'medicaid.medicaidDeniedIndicator';
export const MEDICAID_DENIED_DATE_PATH = 'medicaid.medicaidDeniedDate';
export const VALUES_TO_SYNC_APPLIED_DURING_OE_OR_LIFE_CHANGE_INDICATOR_PATH =
  'valuesToSync.appliedDuringOeOrLifeChangeIndicator';
export const MEDICAID_APPLIED_DURING_OE_OR_LIFE_CHANGE_INDICATOR_PATH =
  'other.appliedDuringOeOrLifeChangeIndicator';

// Medicaid Immigration Questions Page
export const MEDICAID_DENIED_DUE_TO_IMMIGRATION_PATH =
  'medicaid.medicaidDeniedDueToImmigrationIndicator';
export const MEDICAID_DENIED_DUE_TO_IMMIGRATION_LIST_PATH =
  'medicaid.medicaidDeniedDueToImmigrationIndicatorList';
// MEDICAID_DENIED_INDICATOR_PATH is also used on this page

// Health Coverage Page
export const MEMBER_ENROLLED_IN_COVERAGE_PATH = 'member_enrolled_in_coverage';
export const INSURANCE_COVERAGE_PATH = 'insuranceCoverage';

// Medicaid Help Paying for Coverage
export const MEDICAID_UNPAID_BILL_INDICATOR_PATH = 'medicaid.unpaidBillIndicator';

// CHIP Coverage Ended Page
export const CHIP_COVERAGE_ENDED_INDICATOR_PATH = 'chip.coverageEndedIndicator';
export const CHIP_COVERAGE_ENDED_REASON_TYPE_PATH = 'chip.coverageEndedReasonType';

// Attestation Page
export const ATTESTATIONS_NON_INCARCERATION_AGREEMENT_PATH =
  'application.legalAttestations.nonIncarcerationAgreementIndicator';
export const ATTESTATIONS_RENEW_ELIGIBILITY_YEAR_QUANTITY_PATH =
  'application.legalAttestations.renewEligibilityYearQuantity';
export const ATTESTATIONS_RENEW_AGREEMENT_INDICATOR_PATH =
  'application.legalAttestations.renewalAgreementIndicator';
export const ATTESTATIONS_ABSENT_PARENT_AGREEMENT_INDICATOR_PATH =
  'application.legalAttestations.absentParentAgreementIndicator';
export const ATTESTATIONS_CHANGE_INFORMATION_AGREEMENT_INDICATOR_PATH =
  'application.legalAttestations.changeInformationAgreementIndicator';
export const ATTESTATIONS_MEDICAID_REQUIREMENT_AGREEMENT_INDICATOR_PATH =
  'application.legalAttestations.medicaidRequirementAgreementIndicator';
export const ATTESTATIONS_TERMINATE_COVERAGE_INDICATOR_PATH =
  'application.legalAttestations.terminateCoverageOtherMecFoundAgreementIndicator';

export const ATTESTATIONS_RECONCILE_INDICATOR_PATH = 'other.reconcilePtcIndicatorType';
export const ATTESTATIONS_INCARCERATED_PATH = 'other.incarcerationType';

export const CSR_MAP = {
  '01': null,
  '04': 'CS73',
  '05': 'CS87',
  '06': 'CS94',
};
